import { motion } from "framer-motion";

const chapters = [
  {
    n: "01",
    title: "We treat your space like our own",
    body: "Every corner gets the attention we'd give our own home. No shortcuts, no missed spots — just honest, thorough work.",
  },
  {
    n: "02",
    title: "The same friendly faces, every time",
    body: "You'll get to know your cleaner. Consistency builds trust, and trust is the whole reason Betty started this.",
  },
  {
    n: "03",
    title: "Warm, safe, family-friendly products",
    body: "Gentle on your family, pets and surfaces — tough on grime. We're happy to go fully eco on request.",
  },
  {
    n: "04",
    title: "On time, or we make it right",
    body: "We respect your schedule. If we're ever off, we'll always make it right — that's the Betty Bell's promise.",
  },
];

const ease = [0.16, 1, 0.3, 1];

export default function Manifesto() {
  return (
    <section id="manifesto" className="px-6 py-24 md:py-36 bg-[#F7E9CC] border-y border-[#C68A3A]/60" data-testid="manifesto-section">
      <div className="max-w-7xl mx-auto grid lg:grid-cols-12 gap-14">
        <div className="lg:col-span-4">
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, ease }}
            className="text-xs tracking-[0.25em] uppercase text-[#C1440E] font-semibold mb-6"
          >
            Why Betty Bell's
          </motion.p>
          <motion.h2
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, ease }}
            className="font-serif text-4xl sm:text-5xl tracking-tight leading-[1.02]"
          >
            A cleaning company that actually <span className="italic text-[#C1440E]">cares.</span>
          </motion.h2>
          <motion.div
            initial={{ opacity: 0, scale: 0.96 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9, delay: 0.1, ease }}
            className="mt-10 overflow-hidden rounded-3xl border border-[#C68A3A] aspect-square"
          >
            <img
              src="https://images.unsplash.com/photo-1723984790027-ffe34efb18f6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000"
              alt="Wide view of a bright, spotless bathroom"
              className="w-full h-full object-cover"
            />
          </motion.div>
        </div>

        <div className="lg:col-span-8 flex flex-col">
          {chapters.map((c, i) => (
            <motion.div
              key={c.n}
              data-testid={`manifesto-chapter-${c.n}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.05, ease }}
              className="grid grid-cols-[auto_1fr] gap-6 md:gap-10 py-9 border-t border-[#C68A3A]/60 first:border-t-0"
            >
              <span className="font-serif text-3xl md:text-4xl text-[#C68A3A]">{c.n}</span>
              <div>
                <h3 className="font-serif text-2xl md:text-3xl tracking-tight">{c.title}</h3>
                <p className="text-[#5A2E14] mt-3 max-w-xl leading-relaxed">{c.body}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
